import React, {Component} from 'react';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as postActions from '../../../actions/post';
import DataTable from '../../../components/data-table/data-table';
import LocalizedStrings from '../../../localization/strings';

class PartnersContainer extends Component {

    componentWillMount() {
        this.fetch({});
    }
    removePost(post) {
        if (confirm(LocalizedStrings.doYouWantToRemove)) {
            this.props.actions.deletePost(post);
        }
    }

    fetch(params) {
        const fetchParams = {
            ...this.state,
            ...params
        }
        this.setState(fetchParams);
        this.props.actions.fetchPostsPaginated(fetchParams.page, fetchParams.size);
    }

    render() {
        const {items, total, page, loading, total_pages} = this.props.posts;

        var config = {
            cols: [
                {
                    value: 'title',
                    header: LocalizedStrings.title
                }, {
                    value: (item) => {
                        return (
                            <div className="btn-group">
                                <Link to={`/admin/posts/${item.id}`} className="btn">{LocalizedStrings.edit}</Link>
                                <Link to={`/post/${item.slug}`} className="btn">{LocalizedStrings.preview}</Link>
                                <a className="btn btn-red" onClick={this.removePost.bind(this, item)}>{LocalizedStrings.delete}</a>
                            </div>
                        )
                    },
                    header: LocalizedStrings.actions
                }
            ]
        };
        return (
            <div>
                <h3>{LocalizedStrings.posts}</h3>
                <div className="table-actions-row">
                    <Link to="/admin/posts/new" className="btn btn-primary">
                        {LocalizedStrings.newPost}
                    </Link>
                </div>
                <div className="panel">
                    <div className="panel-body">
                        <DataTable config={config} items={items} page={page} total={total} totalPages={total_pages} loadAction={this.fetch.bind(this)} loading={loading}></DataTable>
                    </div>
                </div>
            </div>

        )
    }
}

export default connect(function(state) {
    return {posts: state.post.posts};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...postActions
        }, dispatch)
    };
})(PartnersContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/post/posts-container.js